import { render, staticRenderFns } from "./SicknessInput.vue?vue&type=template&id=795d4a69"
import script from "./SicknessInput.vue?vue&type=script&lang=js"
export * from "./SicknessInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports